import "./block-testimonials-slider.scss";

const $ = jQuery.noConflict();

function initBlockSliderTestimonials() {
    $(".slider-testimonials").each(function onEach() {
        // eslint-disable-next-line no-undef, no-new
        new Swiper($(this)[0], {
            effect: "fade",
            loop: true,

            fadeEffect: {
                crossFade: true,
            },

            a11y: {
                prevSlideMessage: siteObject.strings.next_slide,
                nextSlideMessage: siteObject.strings.next_slide,
            },

            navigation: {
                nextEl: ".slider-testimonials-next",
                prevEl: ".slider-testimonials-prev",
            },

            autoplay: {
                delay: 5000,
            },

            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
        });
    });
}

$(document).ready(function onReady() {
    initBlockSliderTestimonials();
});

if (window.acf) {
    window.acf.addAction("render_block_preview", initBlockSliderTestimonials);
}
